export type TextbookKind = 'checkup' | 'workbook'

export interface TextbookCatalogItem {
  id: string
  series: string
  kind: TextbookKind
  coverImage: string
  sampleUrl: string
  price: number
}

export const TEXTBOOK_CATALOG: TextbookCatalogItem[] = [
  {
    id: 'core-a-checkup',
    series: 'CORE-A',
    kind: 'checkup',
    coverImage: '/textbooks/covers/core-a-checkup.png',
    sampleUrl: '/textbooks/samples/core-a-checkup.pdf',
    price: 14_500,
  },
  {
    id: 'core-b-checkup',
    series: 'CORE-B',
    kind: 'checkup',
    coverImage: '/textbooks/covers/core-b-checkup.png',
    sampleUrl: '/textbooks/samples/core-b-checkup.pdf',
    price: 14_500,
  },
  {
    id: 'core-c-checkup',
    series: 'CORE-C',
    kind: 'checkup',
    coverImage: '/textbooks/covers/core-c-checkup.png',
    sampleUrl: '/textbooks/samples/core-c-checkup.pdf',
    price: 14_500,
  },
  {
    id: 'advanced-checkup',
    series: 'ADVANCED',
    kind: 'checkup',
    coverImage: '/textbooks/covers/advanced-checkup.png',
    sampleUrl: '/textbooks/samples/advanced-checkup.pdf',
    price: 14_500,
  },
  {
    id: 'elite-checkup',
    series: 'ELITE',
    kind: 'checkup',
    coverImage: '/textbooks/covers/elite-checkup.png',
    sampleUrl: '/textbooks/samples/elite-checkup.pdf',
    price: 14_500,
  },
  {
    id: 'core-a-workbook',
    series: 'CORE-A',
    kind: 'workbook',
    coverImage: '/textbooks/covers/core-a-workbook.png',
    sampleUrl: '/textbooks/samples/core-a-workbook.pdf',
    price: 22_000,
  },
  {
    id: 'core-b-workbook',
    series: 'CORE-B',
    kind: 'workbook',
    coverImage: '/textbooks/covers/core-b-workbook.png',
    sampleUrl: '/textbooks/samples/core-b-workbook.pdf',
    price: 22_000,
  },
  {
    id: 'core-c-workbook',
    series: 'CORE-C',
    kind: 'workbook',
    coverImage: '/textbooks/covers/core-c-workbook.png',
    sampleUrl: '/textbooks/samples/core-c-workbook.pdf',
    price: 22_000,
  },
  {
    id: 'core-d-workbook',
    series: 'CORE-D',
    kind: 'workbook',
    coverImage: '/textbooks/covers/core-d-workbook.png',
    sampleUrl: '/textbooks/samples/core-d-workbook.pdf',
    price: 22_000,
  },
  {
    id: 'core-e-workbook',
    series: 'CORE-E',
    kind: 'workbook',
    coverImage: '/textbooks/covers/core-e-workbook.png',
    sampleUrl: '/textbooks/samples/core-e-workbook.pdf',
    price: 22_000,
  },
]
